/**
 * CSV-Zeilen-Validierung + Normalisierung für MA- und Praxismodul-Import
 * (OU-1g.b, Decision #3/#5). Konsolidiertes Format für beide Importe:
 *
 *   KorrigierendeR;Nachname;Vorname;Modul;Modulbezeichnung;Klasse
 *
 * Zusätzliche Spalten (Schüler-Nr, „Modul (2.)", Wahlpflicht, Fach) werden
 * stillschweigend ignoriert. Liegt in `/shared` (CLAUDE.md §26), damit Import-
 * Service (Backend), CLI und FE-Vorschau dieselbe Form-Definition teilen.
 *
 * `normalizeImportClassName` ist bewusst NICHT `normalizeClassName` (utils.ts):
 * der Stammdaten-Normalizer lowercased/trimmt nur, während der Import den festen
 * Jahrgang 9 voranstellt ("b" → "9b", MA = Jg. 9 fix, Decision #5).
 */
import { z } from 'zod';
/**
 * Default header labels of the consolidated import CSV. Index 0..5 map to the
 * six logical columns; the parser resolves them case-insensitively and tolerates
 * extra columns to either side.
 */
export const IMPORT_CSV_DEFAULT_HEADERS = {
    korrigierende: 'KorrigierendeR',
    nachname: 'Nachname',
    vorname: 'Vorname',
    modul: 'Modul',
    modulbezeichnung: 'Modulbezeichnung',
    klasse: 'Klasse',
};
/** Lowercase + trim — the canonical form for name/teacher matching. */
export function normalizeName(s) {
    return s.trim().toLowerCase();
}
/**
 * CSV-Klassen-Buchstabe → normalisierte Klasse mit festem Jahrgang 9
 * ("b" → "9b"). Falls bereits eine Ziffer vorangestellt ist (defensives
 * Verhalten gegenüber abweichenden Listen), wird nur lowercased/getrimmt.
 */
export function normalizeImportClassName(csvValue) {
    const v = csvValue.trim().toLowerCase();
    return /^\d/.test(v) ? v : `9${v}`;
}
export const ImportRowSchema = z.object({
    korrigierende: z.string().trim().min(1, 'Korrigierende:r fehlt.'),
    nachname: z.string().trim().min(1, 'Nachname fehlt.'),
    vorname: z.string().trim().min(1, 'Vorname fehlt.'),
    modul: z.string().trim().min(1, 'Modul fehlt.'),
    modulbezeichnung: z.string().trim().min(1, 'Modulbezeichnung fehlt.'),
    klasse: z
        .string()
        .trim()
        .regex(/^[a-zA-Z]$/, 'Klasse muss ein einzelner Buchstabe (a–z) sein.'),
});
//# sourceMappingURL=assignment-import-validation.js.map